import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';

export const useStoreModalDepositCurrencies = defineStore('modalDepositCurrencies', {
  state: () => ({
    title: '',
    createdCurrenciesTitle: '',
    availableCurrenciesTitle: '',
    availableCryptoTitle: '',
    availableFiatTitle: '',
    modalCryptoToFiatTitle: '',
    availableFiatCurrenciesTitle: '',
    cryptoToFiatExplanationText: '',
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadDepositCurrenciesModal() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('deposit-currencies-modal')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
